import { Injectable } from '@angular/core';
import {CustomerAddress} from "../models/CustomerAddress";

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor() { }

  formatAddressOneLine(address: CustomerAddress){

    let addressString = '';
    let firstFieldFound = false;

    for (const [index, [key, value]] of Object.entries(Object.entries(address))) {

      if(firstFieldFound && value){
        addressString += ', ';
      }

      if(value){
        addressString += value;
        firstFieldFound = true;
      }

    }

    return addressString;

  }

  formatAddress(address: any){

    let addressString = '';
    let firstFieldFound = false;

    let i = 0;
    for (const [index, [key, value]] of Object.entries(Object.entries(address))) {

      if(firstFieldFound && value){

        i++;

        if(!this.isOdd((i)) && (i) > 0){
          addressString += ', <br/>';

        }else{
          addressString += ', ';
        }

      }

      if(value){

        if(key === 'postcode'){
          addressString += (value as any).toUpperCase();
        }else{
          addressString += this.toTitleCase((value as any));
        }

        firstFieldFound = true;
      }

    }

    return addressString;

  }

  isOdd(num: number) { return num % 2;}

  toTitleCase(str: string) {
    return str.replace(
      /\w\S*/g,
      function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }


}
